export default __webpack_public_path__ + "static/media/gallery_00.5d46bd21.jpg";